/* Shinto's Dog Food Calculator — v3. Loads with #calculator section.
   v3 changes (client feedback):
   - Starter kit fully removed from the calculator: no protein choice in step 1,
     no kit image in the plan, no starter-kit products behind Subscribe.
   - Container sizes match real products: fresh food ships in 32 oz only.
     If a 16 oz food size gets confirmed, add 16 to SIZES and a '16' variant
     id in SUBSCRIBE.variants — the size picker reappears automatically.
   - Warming note (bone marrow stock) is static markup in the section. */
(function(){
  var root=document.getElementById('calculator');
  if(!root||!root.querySelector('#to2'))return;
  var $=function(s){return root.querySelector(s)};
  var store=(function(){try{localStorage.setItem('__t','1');localStorage.removeItem('__t');return localStorage}catch(e){var m={};return{getItem:function(k){return k in m?m[k]:null},setItem:function(k,v){m[k]=''+v},removeItem:function(k){delete m[k]}}}})();

  /* ---- config ---- */
  var DAYS=30;
  var SIZES=[32];                 /* real container sizes; with a single size the picker stays hidden */
  var rate={adult:0.4,puppy:0.8}; /* oz per lb of body weight per day */
  var plan='full', selSize=null, step=1;

  /* kidney support → link customers to the fiber-mixer collection (16 oz & 32 oz).
     EDIT this URL to your real collection page. */
  var KIDNEY_COLLECTION_URL='/collections/fiber-mixers-new';

  /* >>> FILL BEFORE PUBLISHING <<<
     The rotational subscription product the Subscribe button links to.
     handle      = product handle (e.g. 'rotational-feeding-subscription')
     sellingPlan = Appstle selling plan id (e.g. '2148270161')
     variants    = variant id per container size (e.g. {'32':'59804548235345'})
     Until handle is filled, the button stays inactive (#). */
  var SUBSCRIBE={
    handle:'',
    sellingPlan:'',
    variants:{'32':''}
  };
  function subscribeUrl(size,qty){
    if(!SUBSCRIBE.handle) return '#';
    var u='/products/'+SUBSCRIBE.handle+'?quantity='+qty;
    var v=SUBSCRIBE.variants[String(size)];
    if(v) u+='&variant='+v;
    if(SUBSCRIBE.sellingPlan) u+='&selling_plan='+SUBSCRIBE.sellingPlan;
    return u;
  }

  /* ---- stepper / nav ---- */
  function goStep(n){
    step=n;
    ['1','2','3'].forEach(function(k){$('#step'+k).classList.toggle('is-on',k===''+n)});
    root.querySelectorAll('.stepper__item').forEach(function(it){
      var s=+it.dataset.s;
      it.classList.toggle('is-active',s===n);
      it.classList.toggle('is-done',s<n);
    });
    if(n===1){$('#wizTitle').textContent="Your dog's profile";$('#wizSub').textContent="Tell us about your dog once — we'll build the plan."}
    else if(n===2){$('#wizTitle').textContent="Lifestyle & preferences";$('#wizSub').textContent="A few more details to fine-tune the recipes."}
    else{$('#wizTitle').textContent="Your dog's plan";$('#wizSub').textContent="Review your plan and subscribe.";compute();var sc=$('#resScroll');if(sc)sc.scrollTop=0}
  }

  /* ---- compute ---- */
  function compute(){
    var w=parseFloat($('#dogWeight').value)||0, stage=$('#dogAge').value, name=($('#dogName').value||'').trim();
    var factor=plan==='full'?1:0.5;
    var daily=w*rate[stage]*factor, monthly=daily*DAYS, meal=daily/2, efa=Math.round(w);
    $('#wVal').textContent=w;
    $('#planReady').textContent=(name?name+"'s":"Your dog's")+' plan is ready';
    $('#rDaily').textContent=daily.toFixed(1);
    $('#rMonthly').textContent=Math.round(monthly);
    $('#rMeal').textContent=meal.toFixed(1);
    $('#rEfa').textContent=efa;
    $('#rFoot').innerHTML=plan==='full'
      ? 'Full fresh rotational diet at <b>~'+(stage==='puppy'?'8':'4')+' oz per 10 lb</b>. Omega-3 dosing 1 drop per pound.'
      : '<b>Supplement feeding</b> — half the full amount, fed alongside your dog\'s regular food.';

    /* live supplemental note: full vs half oz/day for this dog */
    var note=$('#suppNote');
    if(note){
      note.hidden=plan!=='supp';
      var fullDaily=w*rate[stage];
      $('#suppFull').textContent=fullDaily.toFixed(1)+' oz/day';
      $('#suppHalf').textContent=(fullDaily*0.5).toFixed(1)+' oz/day';
    }

    renderContainers(daily,monthly);
    renderDiagram(daily);
    renderKidney();
  }

  /* single source of truth for the chosen container size */
  function pickSize(daily){
    if(SIZES.length===1||!daily) return SIZES[0];
    if(selSize&&SIZES.indexOf(selSize)!==-1) return selSize;
    var diffs=SIZES.map(function(s){return Math.abs(s/daily-8)});
    return SIZES[diffs.indexOf(Math.min.apply(null,diffs))];
  }

  function renderContainers(daily,monthly){
    var chosen=pickSize(daily);
    var qty=Math.max(1,Math.ceil(monthly/chosen));
    var opts=$('#bfOpts');
    if(opts){
      if(SIZES.length>1){
        var diffs=SIZES.map(function(s){return Math.abs(s/daily-8)});
        var bestIdx=diffs.indexOf(Math.min.apply(null,diffs));
        opts.innerHTML=SIZES.map(function(s,i){
          var q=Math.max(1,Math.ceil(monthly/s));
          var cls='bf-opt'+(s===chosen?' bf-opt--active':'');
          return '<div class="'+cls+'" data-size="'+s+'"><span class="s">'+s+' oz</span><span class="q">'+q+' <small>qty</small></span>'+(i===bestIdx?'<span class="best">Best</span>':'')+'</div>';
        }).join('');
        opts.hidden=false;
      }else{
        opts.innerHTML='';
        opts.hidden=true;
      }
    }
    $('#bfSize').textContent=chosen+' oz container';
    $('#bfNeed').textContent='You need '+qty+' × '+chosen+' oz per month';
    $('#subLbl').textContent='Subscribe · '+chosen+' oz × '+qty;
    var sb=$('#subBtn'); if(sb) sb.href=subscribeUrl(chosen,qty);
  }

  function renderDiagram(daily){
    var fc=$('#feedcard');
    if(!fc||!daily){return}
    var chosen=pickSize(daily);

    /* container = 2 rows of 4 oz squares, read across as days */
    var SQ=4;                              /* each square = 4 oz (how the pack is scored) */
    var rows=2;
    var totalSq=Math.round(chosen/SQ);     /* 32 → 8 squares */
    var perDay=daily/SQ;                   /* squares per day */
    var days=Math.max(1,Math.ceil(chosen/daily));
    var dayWord=days>1?'days':'day';

    /* build squares in COLUMN order (grid-auto-flow:column fills top→bottom) */
    var cells='';
    for(var i=0;i<totalSq;i++){
      var day=Math.floor((i+0.0001)/perDay);           /* 0-based day this square belongs to */
      var prevDay=i===0?-1:Math.floor((i-0.9999)/perDay);
      var firstOfDay=day!==prevDay;
      var cls='fc-sq '+(day%2===0?'fc-sq--a':'fc-sq--b');
      var badge=firstOfDay?'<span class="fc-daybadge">Day '+(day+1)+'</span>':'';
      cells+='<div class="'+cls+'">'+badge+SQ+' oz</div>';
    }

    fc.innerHTML=
      '<div class="fc-stats">'+
        '<div class="fc-stat fc-stat--hl"><b>~'+days+'</b><span>Days it lasts</span></div>'+
        '<div class="fc-stat"><b>'+daily.toFixed(1)+'</b><span>oz per day</span></div>'+
        '<div class="fc-stat"><b>'+SQ+'</b><span>oz per square</span></div>'+
      '</div>'+
      '<div class="fc-container">'+
        '<div class="fc-lid"><span>'+chosen+' oz container</span><span class="cap">cut into '+SQ+' oz squares</span></div>'+
        '<div class="fc-scroll"><div class="fc-grid" style="grid-template-rows:repeat('+rows+',56px)">'+cells+'</div></div>'+
        '<div class="fc-legend"><span class="a"><i></i>Day (odd)</span><span class="b"><i></i>Day (even)</span></div>'+
        '<div class="fc-cap"><b>'+chosen+' oz</b> = '+totalSq+' squares of '+SQ+' oz. At <b>'+daily.toFixed(1)+' oz/day</b> that\'s <b>'+(perDay%1===0?perDay:perDay.toFixed(1))+' squares a day</b> — about <b>'+days+' '+dayWord+'</b>.</div>'+
      '</div>';
  }

  /* kidney selected → show a callout linking to the fiber-mixer collection */
  function renderKidney(){
    var box=$('#kidneyBox');if(!box)return;
    var on=$('#healthNeeds').value==='kidney';
    box.hidden=!on;
    if(!on){box.innerHTML='';return}
    box.innerHTML=
      '<div class="kidney__t">🩺 Kidney support</div>'+
      '<p class="kidney__p">For dogs with kidney issues we substitute about <b>25% of the container</b> with fiber mixers. Choose one, several, or all of them:</p>'+
      '<a class="kidney__btn" href="'+KIDNEY_COLLECTION_URL+'">Shop fiber mixers →</a>';
  }

  /* ---- events ---- */
  $('#to2').addEventListener('click',function(){goStep(2)});
  $('#to3').addEventListener('click',function(){goStep(3)});
  $('#back1').addEventListener('click',function(){goStep(1)});
  $('#back2').addEventListener('click',function(){
    goStep(2);
    var top=document.querySelector('#calculator')||document.querySelector('.wiz');
    if(top) top.scrollIntoView({behavior:'smooth',block:'start'});
  });

  $('#plan').addEventListener('click',function(e){var b=e.target.closest('.chip');if(!b)return;this.querySelectorAll('.chip').forEach(function(c){c.setAttribute('aria-pressed','false')});b.setAttribute('aria-pressed','true');plan=b.dataset.plan;compute()});
  $('#activity').addEventListener('change',compute);
  $('#healthNeeds').addEventListener('change',compute);
  ['#dogWeight','#dogAge','#dogName'].forEach(function(s){$(s).addEventListener('input',compute)});

  ['#proteins','#goals'].forEach(function(s){$(s).addEventListener('click',function(e){var b=e.target.closest('.chip');if(!b)return;b.setAttribute('aria-pressed',b.getAttribute('aria-pressed')==='true'?'false':'true')})});

  $('#bfOpts').addEventListener('click',function(e){var o=e.target.closest('.bf-opt');if(!o)return;selSize=parseInt(o.dataset.size,10);compute()});

  /* save / reset (step 1 only) */
  $('#saveProfile').addEventListener('click',function(){
    store.setItem('dogProfileV2',JSON.stringify({name:$('#dogName').value,age:$('#dogAge').value,weight:$('#dogWeight').value,plan:plan,health:$('#healthNeeds').value}));
    var m=$('#saveMsg');m.hidden=false;setTimeout(function(){m.hidden=true},2000);
  });
  $('#resetProfile').addEventListener('click',function(){
    store.removeItem('dogProfileV2');
    $('#dogName').value='';$('#dogAge').value='adult';$('#dogWeight').value=30;$('#healthNeeds').value='';
    plan='full';selSize=null;
    $('#plan').querySelectorAll('.chip').forEach(function(c){c.setAttribute('aria-pressed',c.dataset.plan==='full'?'true':'false')});
    compute();
  });

  function load(){
    var s=store.getItem('dogProfileV2');if(!s)return;var d=JSON.parse(s);
    $('#dogName').value=d.name||'';$('#dogAge').value=d.age||'adult';$('#dogWeight').value=d.weight||30;$('#healthNeeds').value=d.health||'';
    plan=d.plan||'full';
    $('#plan').querySelectorAll('.chip').forEach(function(c){c.setAttribute('aria-pressed',c.dataset.plan===plan?'true':'false')});
  }

  load();compute();goStep(1);
})();

